import redirectToOnboardingIfRequired from "@/shared/router/guards/redirectToOnboardingIfRequired";

export default {
  default: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/DashboardView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/onboarding",
      name: "onboarding",
      component: () => import("./views/OnboardingView.vue")
    },
    {
      path: "/psd/callback",
      name: "psdCallback",
      component: () => import("./views/PsdCallbackView.vue")
    },
    {
      path: "/leningen",
      name: "loans.view",
      component: () => import("./views/LoansView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/leningen/aanvragen",
      name: "loans.requestForm",
      component: () => import("./views/LoanRequestView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/leningen/:id/verlengen",
      name: "loans.extendForm",
      component: () => import("./views/LoanExtendView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/inbox-redirect-loans/:id",
      redirect: { name: "loans.view.detail" }
    },
    {
      path: "/leningen/:id",
      name: "loans.view.detail",
      component: () => import("./views/LoanDetailView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/leningen/:id/eerder-terugbetalen",
      name: "loans.earlyRepayment",
      component: () => import("./views/EarlyRepaymentView.vue"),
      beforeEnter: redirectToOnboardingIfRequired
    },
    {
      path: "/sepa-callback",
      name: "sepaCallback",
      component: () => import("./views/SepaCallbackView.vue")
    },
    {
      path: "/mollie-callback",
      name: "mollieCallback",
      redirect: { name: "onboarding" }
    }
  ]
};
